module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB4SURBVHgB1ZPdCYAwDIQTF7GjdARXcRLdwBHUDdzEOkkM2odD8DdF6Pdy19AeB6FE2SAijixoQCM7PX1FH4cYMl/dKygBSUIYD1q7U/EwcuAD+IGZ62PYtgV5hztr0qpUMCrBL9hKm3h6Qn7buQuZoo5kwfx3fmUFCThoZBTF7TQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Images/profileplus.png
// module id = 1190
// module chunks = 0